import { c as _c } from "react/compiler-runtime";
import { useAffiliateDashboardVendors } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-vendors';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { VendorId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface';
import React, { useEffect, useMemo, useState } from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateVendorSelectorProps {
  selectedVendor?: VendorId;
  setFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardVendorSelector = t0 => {
  const $ = _c(15);
  const {
    selectedVendor,
    setFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [shouldFetch, setShouldFetch] = useState(false);
  let t1;
  let t2;
  if ($[0] !== selectedVendor) {
    t1 = () => {
      if (selectedVendor) {
        setShouldFetch(true);
      }
    };
    t2 = [selectedVendor];
    $[0] = selectedVendor;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const {
    data: vendors
  } = useAffiliateDashboardVendors(shouldFetch);
  let t3;
  if ($[3] !== vendors) {
    t3 = vendors?.map(_temp);
    $[3] = vendors;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const vendorsData = t3;
  let t4;
  if ($[5] !== setFilter) {
    t4 = vendorId => setFilter(prev => ({
      ...prev,
      vendorId
    }));
    $[5] = setFilter;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setShouldFetch(true);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("dashboard.affiliate_dashboard.all_vendors");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== selectedVendor || $[11] !== t4 || $[12] !== t6 || $[13] !== vendorsData) {
    t7 = <FormSelect data={vendorsData} onChange={t4} onOpen={t5} placeholder={t6} value={selectedVendor} />;
    $[10] = selectedVendor;
    $[11] = t4;
    $[12] = t6;
    $[13] = vendorsData;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default AffiliateDashboardVendorSelector;
function _temp(t0) {
  const {
    vendor
  } = t0;
  return {
    caption: vendor.affiliateProgramBrandName,
    id: vendor.id
  };
}